var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{directives:[{name:"accessibility-focus",rawName:"v-accessibility-focus",value:(_vm.toggleFullscreen),expression:"toggleFullscreen"}],staticClass:"o-icon o-icon--maximize",attrs:{"aria-label":_vm.$t('accessibility.player.fullscreen')}})
}
var staticRenderFns = []

export { render, staticRenderFns }